import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { FormattedMessage, useIntl } from 'react-intl';

const ReduxFormInputTranslation: React.FC = (field: any) => {
  return (
    <FormGroup row={false} className={field.className}>
      {field.label && (
        <Label>
          <FormattedMessage {...field.label} />
        </Label>
      )}
      <Input
        {...field.input}
        type={field.type}
        placeholder={
          field.placeHolder ? useIntl().formatMessage(field.placeHolder) : null
        }
        max={field.maxDate}
        min={field.minDate}
        step={field.step}
        disabled={field.disabled}
      />
      {field.meta.touched && field.meta.error && (
        <p className="text-danger">
          <FormattedMessage id={field.meta.error} />
        </p>
      )}
      {field.loc?.value && (
        <ul className="ms-3">
          {field.loc.value
            .filter(
              (l: { name: string; value: string }) => l.name === field.input.value,
            )
            .map((loc: any, index: number) => (
              <li key={index}>EN: {loc.value}</li>
            ))}
          {!field.loc.value
            .some(
              (l: { name: string; value: string }) => l.name === field.input.value,
            ) && (<li>EN: NOT FOUND</li>)}
        </ul>
      )}
    </FormGroup>
  )
};

export default ReduxFormInputTranslation;
